import { ActionType } from "../../model/actionTypes";
import { errorHandler } from "./auth";

export const getOdInsPlansUcr = (practiceIds: number[]) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.get("openDental/insPlansUcr", null, { practiceIds: JSON.stringify(practiceIds) });
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch(errorHandler(err));
        return [];
    }
};

// No global loader: the page calls this once per practice and shows its own progress
export const updateOdInsPlansUcr = (practiceId: number) => async (dispatch: Function, getState: Function, api: any) => {
    try {
        return await api.put("openDental/insPlansUcr", { practiceId }, null);
    } catch (err: any) {
        return { practiceId, success: false, error: (err && err.message) || "Request failed" };
    }
};
